import { monthlyHourlyRate } from "./monthlySalary";
// The shift's worked hours already exclude absence. Only monthly salary needs
// an absence deduction; hourly salary instead adds the paid part of absence.
export function calculateAbsencePay(absence, payType, payAmount, settings = {}) {
  const hours = Math.max(0, Number(absence?.hours || 0));
  const unpaidHours = Math.min(hours, Math.max(0, Number(absence?.value || 0)));
  const rate = Math.max(0, Number(payAmount || 0));

  return {
    paidHours: hours - unpaidHours,
    deduction: payType === "monthly" ? unpaidHours * monthlyHourlyRate(rate, settings) : 0,
  };
}
